var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-container is-flex justify-center align-center hero-section",style:(_vm.heroStyle)},[_vm._m(0),_c('div',{staticClass:"auth-form"},[_c('el-card',[_c('login-form')],1)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"auth-form-img",staticStyle:{"width":"750px"}},[_c('br')])
}]

export { render, staticRenderFns }